import * as React from 'react';

import {Radio} from 'shells/radio/radio';
import {RadioGroupSlider} from 'shells/radio/radio-group-slider';
// @ts-expect-error
import {getInstanceCurrencyPrefix} from 'shells/utils/currency';

import type {ReportFacet} from './report-types';

import styles from './facet-picker.module.css';

type FacetPickerProps = {
    facet: ReportFacet;
    onFacetChange: (...args: any) => any;
};

export function FacetPicker(props: FacetPickerProps) {
    return (
        <div className={styles['facet-picker']}>
            <RadioGroupSlider
                name='displayType'
                size='big'
                selectedValue={props.facet}
                selectedIndex={props.facet === 'total' ? 0 : 1}
                onChange={props.onFacetChange}
            >
                <Radio value='total'>
                    <span title='Value' className={styles.icon}>
                        {getInstanceCurrencyPrefix()}
                    </span>
                    <span className={styles['icon-label']}>Value</span>
                </Radio>
                <Radio value='count'>
                    <span title='Quantity' className={styles.icon}>
                        #
                    </span>
                    <span className={styles['icon-label']}>Quantity</span>
                </Radio>
            </RadioGroupSlider>
        </div>
    );
}
